module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templates-action-picker-wrapper"
  }, [_c('div', {
    staticClass: "linked-list"
  }, _vm._l((_vm.actions), function(action, action_index) {
    return (!action._destroy) ? _c('div', {
      key: action_index,
      staticClass: "linked-item"
    }, [_c('div', {
      staticClass: "row action-picker"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_c('type-picker', {
      attrs: {
        "reference": action_index,
        "action": action,
        "templates": _vm.templates,
        "actions": _vm.actions,
        "flow": _vm.flow,
        "options": _vm.options
      },
      on: {
        "change": _vm.setActionType
      }
    })], 1), _c('div', {
      staticClass: "col-sm-4 no-padding"
    }, [_c('send-at-picker', {
      attrs: {
        "reference": action_index,
        "allow_send_at_immediately": action.is_first,
        "action": action,
        "actions": _vm.actions,
        "flow": _vm.flow
      },
      on: {
        "change": _vm.setActionSendAt
      }
    })], 1), _c('div', {
      staticClass: "col-sm-1"
    }, [(!action.is_first && _vm.flow.canEditActions()) ? _c('div', {
      staticClass: "btn-icon-remove",
      on: {
        "click": function($event) {
          return _vm.removeAction(action_index)
        }
      }
    }) : _vm._e()])])]) : _vm._e()
  }), 0), (_vm.flow.canEditActions()) ? _c('div', {
    staticClass: "btn btn-clean",
    attrs: {
      "id": "add-action"
    },
    on: {
      "click": function($event) {
        return _vm.addAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.actions.addAction')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-021591b5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow_actions/picker.vue
// module id = 1005
// module chunks = 1